import { Cell, CellType } from '../_base/table-cell.entity';

export class BooleanCell extends Cell {
    constructor(
        public readonly value: boolean | null,
        public readonly disabled = false
    ) {
        super(CellType.BOOLEAN);
    }
}
